import { Word } from 'interfaces/db/word'
import { formatSeconds } from './format-seconds'
export const srtGenerator = (vttJSON: Word[]) => {
  let srtOut = ''
  vttJSON.forEach((v, i) => {
    srtOut += `${i + 1}\n${formatSeconds(v.start).replace(
      '.',
      ','
    )} --> ${formatSeconds(v.end).replace('.', ',')}\n${v.text.trim()}\n\n`
  })

  return srtOut
}
